import registerLoading from './loading'
import registerFly from './fly'

export default function registerDirective(app) {
  registerLoading(app)
  registerFly(app)
}
